module.exports = __webpack_public_path__ + "assets/917b741dc7f8227906b0fd1dbd0a78ef.png";